var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"dark":"","color":"blue"}},[_c('v-toolbar-title',[_c('img',{staticStyle:{"margin-top":"10px"},attrs:{"src":require("../../../../assets/logo.png"),"height":"52px"}})]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }